import apiClient from "./apiClient";
import { decodeBase64Json } from "../utils/decodeBase64Json";

export const getAuditLogs = async () => {
  const response = await apiClient.post("/DS/admin_center/audit_log.zjs");

  const raw = response?.data?.[0]?.ResultBase64;
  const decoded = raw ? decodeBase64Json(raw) : response?.data;

  const payload = decoded?.result || decoded?.Result || decoded;

  return {
    total: payload?.TOTAL_LOGS ?? payload?.logs?.length ?? payload?.LOGS?.length ?? 0,
    logs: payload?.LOGS || payload?.logs || payload?.data || payload?.Data || [],
  };
};
